class AnimationElement extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('low-power-fallback') || !this.posterUrl) {
      // If we're not adding a low-power fallback, or if there's no available
      // poster, then there's no behavior here. Short circuit.
      return;
    }

    this.startPlayback();
  }

  disconnectedCallback() {
    this.video.removeEventListener('canplay', this.startPlayback);
  }

  get posterUrl() {
    return this.video?.poster;
  }

  get video() {
    return this.querySelector('video');
  }

  get playing() {
    const video = this.video;
    return !video.paused && !video.ended && video.readyState > 2;
  }

  togglePoster(shown) {
    if (shown) {
      this.style.backgroundImage = `url(${this.posterUrl})`;
      this.video.style.visibility = 'hidden';
    } else {
      this.style.backgroundImage = null;
      this.video.style.visibility = 'visible';
    }
  }

  startPlayback = (_event) => {
    // To test low-power fallback uncomment this line.
    // return this.togglePoster(true);

    // We can just bail if the video is already playing.
    if (this.playing) {
      return;
    }

    // If the video is loaded but not playing, then try to trigger it manually.
    if (this.video.readyState > 2) {
      this.video.play().catch(() => {
        // The primary reason a video would error here is that iOS is
        // forbidding autoplay because of low-power mode. We just fall back to
        // the poster if that's the case.
        this.togglePoster(true);
      });
    } else {
      this.video.addEventListener('canplay', this.startPlayback, {
        once: true,
        passive: true,
      });
    }
  };
}

if (!window.customElements.get('tmp-animation')) {
  window.AnimationElement = AnimationElement;
  window.customElements.define('tmp-animation', AnimationElement);
}
